/* CARTRI - Personaliza tu pack. Suma lo elegido, calcula el ahorro
   frente al precio anterior, muestra la progress bar de desbloqueo del
   reloj Garett (a partir de un umbral) y añade el regalo automáticamente. */
(function () {
  'use strict';
  var CFG = window.LIQ || {};
  var UMBRAL = CFG.freeShippingThreshold || 0;

  function money(c) {
    try {
      return new Intl.NumberFormat(CFG.locale || 'es-ES', {
        style: 'currency', currency: CFG.currency || 'EUR'
      }).format(c / 100);
    } catch (e) { return (c / 100).toFixed(2) + ' EUR'; }
  }

  function init(root) {
    if (!root || root.hasAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');

    var UNLOCK = Number(root.getAttribute('data-unlock-threshold')) || 0;
    var UNLOCK_VARIANT = root.getAttribute('data-unlock-variant') || '';
    var UNLOCK_TITLE = root.getAttribute('data-unlock-title') || '';
    var UNLOCK_PRICE = Number(root.getAttribute('data-unlock-price')) || 0;

    var opts = [].slice.call(root.querySelectorAll('[data-liq-opt]'));
    var listEl = root.querySelector('[data-sum-list]');
    var emptyEl = root.querySelector('[data-sum-empty]');
    var antesEl = root.querySelector('[data-sum-antes]');
    var totalEl = root.querySelector('[data-sum-total]');
    var saveEl = root.querySelector('[data-sum-save]');
    var shipEl = root.querySelector('[data-sum-ship]');
    var unlockEl = root.querySelector('[data-sum-unlock]');
    var unlockLabel = root.querySelector('[data-unlock-label]');
    var unlockFill = root.querySelector('[data-unlock-fill]');
    var btn = root.querySelector('[data-sum-add]');
    if (!opts.length || !btn) return;

    function num(el, attr) { return Number(el.getAttribute(attr)) || 0; }

    function elegirRegalo(total) {
      var conRegalo = opts.filter(function (o) {
        return num(o, 'data-n') > 0 && o.getAttribute('data-gift-variant');
      });
      if (conRegalo.length) {
        var oro = conRegalo.filter(function (o) {
          return (o.getAttribute('data-gift-title') || '').indexOf('Oro') !== -1;
        });
        var g = (oro.length ? oro : conRegalo)[0];
        return {
          variant: g.getAttribute('data-gift-variant'),
          title: g.getAttribute('data-gift-title') || 'Regalo',
          price: num(g, 'data-gift-price')
        };
      }
      if (UNLOCK && total >= UNLOCK && UNLOCK_VARIANT) {
        return { variant: UNLOCK_VARIANT, title: UNLOCK_TITLE, price: UNLOCK_PRICE };
      }
      return null;
    }

    function pintar() {
      var total = 0, antes = 0, filas = '', unidades = 0;

      opts.forEach(function (o) {
        var n = num(o, 'data-n');
        var max = num(o, 'data-max') || 99;
        o.classList.toggle('is-on', n > 0);
        var menos = o.querySelector('[data-menos]');
        var mas = o.querySelector('[data-mas]');
        var cifra = o.querySelector('[data-cifra]');
        if (cifra) cifra.textContent = n;
        if (menos) menos.disabled = n <= 0;
        if (mas) mas.disabled = n >= max;
        if (!n) return;
        unidades += n;
        var p = num(o, 'data-price');
        var c = num(o, 'data-compare') || p;
        total += p * n;
        antes += c * n;
        filas += '<li><span>' + (n > 1 ? n + ' x ' : '') +
          (o.getAttribute('data-title') || '') + '</span><span>' + money(p * n) + '</span></li>';
      });

      var regalo = elegirRegalo(total);
      var desbloqueado = UNLOCK > 0 && total >= UNLOCK;
      if (regalo) {
        antes += regalo.price;
        filas += '<li class="is-gift"><span>&#127873; ' + regalo.title + ' (regalo)</span>' +
          '<span class="liq-garett__gift-total"><s>' + money(regalo.price) + '</s> GRATIS</span></li>';
      }

      if (listEl) listEl.innerHTML = filas;
      if (emptyEl) emptyEl.hidden = unidades > 0;
      if (antesEl) antesEl.innerHTML = antes > total ? '<s>' + money(antes) + '</s>' : '';
      if (totalEl) totalEl.textContent = money(total);

      if (unlockEl && UNLOCK > 0) {
        unlockEl.hidden = false;
        var pct = Math.min(100, Math.round(total / UNLOCK * 100));
        if (unlockFill) unlockFill.style.width = pct + '%';
        root.classList.toggle('is-unlocked', desbloqueado);
        unlockEl.classList.toggle('is-done', desbloqueado);
        if (unlockLabel) {
          unlockLabel.innerHTML = desbloqueado
            ? '&#127873; Regalo desbloqueado: <b>' + UNLOCK_TITLE + '</b> GRATIS'
            : 'Te faltan <b>' + money(UNLOCK - total) + '</b> para tu reloj Garett de regalo';
        }
      }

      if (saveEl) {
        var save = antes - total;
        if (save > 0) {
          saveEl.hidden = false;
          saveEl.textContent = 'Te ahorras ' + money(save) + ' con este pack';
        } else { saveEl.hidden = true; }
      }

      if (shipEl && UMBRAL) {
        if (!unidades) {
          shipEl.hidden = true;
        } else if (total >= UMBRAL) {
          shipEl.hidden = false;
          shipEl.className = 'liq-sum__ship is-done';
          shipEl.textContent = 'Envio gratis incluido';
        } else {
          shipEl.hidden = false;
          shipEl.className = 'liq-sum__ship';
          shipEl.textContent = 'Te faltan ' + money(UMBRAL - total) + ' para el envio gratis';
        }
      }

      btn.disabled = unidades === 0;
      btn.textContent = unidades === 0
        ? (btn.getAttribute('data-empty-label') || 'Elige tu equipo')
        : 'Anadir ' + unidades + (unidades === 1 ? ' articulo' : ' articulos') + ' al carrito';
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-mas],[data-menos]') : null;
      if (!b) return;
      e.preventDefault();
      var o = b.closest('[data-liq-opt]');
      if (!o) return;
      var n = num(o, 'data-n');
      var max = num(o, 'data-max') || 99;
      n = b.hasAttribute('data-mas') ? Math.min(max, n + 1) : Math.max(0, n - 1);
      o.setAttribute('data-n', n);
      pintar();
    });

    btn.addEventListener('click', function () {
      var items = [];
      var total = 0;
      opts.forEach(function (o) {
        var n = num(o, 'data-n');
        if (n > 0) {
          items.push({ id: Number(o.getAttribute('data-variant')), quantity: n });
          total += num(o, 'data-price') * n;
        }
      });
      if (!items.length) return;

      var regalo = elegirRegalo(total);
      if (regalo && !items.some(function (i) { return i.id === Number(regalo.variant); })) {
        items.push({ id: Number(regalo.variant), quantity: 1 });
      }

      var txt = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Anadiendo...';
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({
          items: items,
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var d = document.querySelector('cart-drawer');
          if (d && typeof d.renderContents === 'function') {
            d.renderContents(data);
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          } else { window.location.href = '/cart'; }
        })
        .catch(function () { window.location.href = '/cart'; })
        .then(function () { btn.disabled = false; btn.textContent = txt; });
    });

    pintar();
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-liq-pack]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
